// トップスライダーの起動 // Launch the top slider

const logoSwiper = new Swiper(".logoSwiper", {
  loop: true, // ループ有効
  slidesPerView: "auto",
  centeredSlides: true,
  speed: 2000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});

const swiperWorks = new Swiper(".swiperWorks", {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 80,

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 80,
    },
  },
});

const swiperCompany = new Swiper(".swiperCompany", {
  loop: true,
  slidesPerView: 2.5,
  spaceBetween: 16,
  speed: 10000,
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 16,
    },
  },
});
// const articleSwiper = new Swiper(".c-articleSwiper", {
//   loop: true,
//   slidesPerView: 2, // 一度に表示する枚数
//   centeredSlides: true,
//   spaceBetween: 24,
//   // 前後の矢印
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   569: {
//     slidesPerView: 3,
//   },
// });

(() => {
  let swiper, swiperbool;
  const breakPoint = 568;

  window.addEventListener(
    "load",
    () => {
      if (breakPoint > window.innerWidth) {
        swiperbool = false;
      } else {
        createSwiper();
        swiperbool = true;
      }
    },
    false
  );

  window.addEventListener(
    "resize",
    () => {
      if (breakPoint > window.innerWidth && swiperbool) {
        swiper.destroy(false, true);
        swiperbool = false;
      } else if (breakPoint <= window.innerWidth && !swiperbool) {
        createSwiper();
        swiperbool = true;
      }
    },
    false
  );

  function createSwiper() {
    articleSwiper = new Swiper(".c-articleSwiper", {
      loop: true,
      slidesPerView: 2, // 一度に表示する枚数
      centeredSlides: true,
      spaceBetween: 24,
      // 前後の矢印
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
        },
      },
    });
  }
})();
